import React, { Component } from "react";
import { connect } from "react-redux";

import { getSearchResults } from "../../../actions/search";
import Spinner from "../../../components/Library/Spinner";
import Layout from "../../../components/Library/Layout";
import Sidebar from "../../../components/Library/Layout/Sidebar";
import Content from "../../../components/Library/Layout/Content";
import StoriesStream from "../../../components/Library/StoriesStream";
import Header from "../../../components/Library/Header";

import styles from "./SearchResults.css";

class SearchResults extends Component {
  constructor(props) {
    super(props);
    this.loadNextStories = this.loadNextStories.bind(this);

    this.state = {
      search: this.props.location.search.slice(1),
    };
  }

  componentDidMount() {
    this.props.getSearchResults(this.state.search);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.location.search !== nextProps.location.search) {
      const nextSearch = nextProps.location.search.slice(1);
      this.props.getSearchResults(nextSearch);
      this.setState({ search: nextSearch });
    }
  }

  loadNextStories(page) {
    return this.props.getSearchResults(this.state.search, page, true);
  }

  render() {
    const { search } = this.props;
    if (search.results.length === 0 && search.isLoading) return <Spinner/>;

    const isEmpty = !search.isLoading && search.isFinished && search.results.length === 0;
    const header = <Header className={styles.clipboard} text={`“${this.state.search}”`} subText="Search Results"/>;

    return (
      <Layout includeHeader headerComponent={header}>
        {!isEmpty && <Sidebar>{" "}</Sidebar>}
        <Content className={isEmpty ? styles.content : {}}>
          {
            isEmpty ?
              <div className={styles.empty}>
                Your search for “{this.state.search}” did not match any results.
              </div> :

              <StoriesStream
                stories={search}
                isSummary={true}
                showUnread={false}
                next={this.loadNextStories}/>
          }
        </Content>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    search: state.search,
  };
};

export default connect(mapStateToProps, { getSearchResults })(SearchResults);



// WEBPACK FOOTER //
// ./src/search/components/SearchResults/SearchResults.js